import { styled, Flex } from '@acko-tech/building-blocks.ui.common'

export const AbhaRootContainer = styled(Flex)`

    max-width: ${(props) => (props.setMaxWidth ? '472px' : '')};

    & h2{
      font-size: 28px;
      margin-bottom: 16px;
      width: 60%;
      position: relative;
      @media screen and (max-width: 768px){
        font-size: 25px;
        text-align: left;
      }
    }
    & h2:before{
      content: " ";
      position: absolute;
      top: 0;
      left: 0;
      width: 100px;
      height: 100px;
      background: #6100FF;
      -webkit-filter: blur(100px);
      filter: blur(100px);
    }
    & > div{
      padding:30px 20px;
      @media screen and (max-width: 768px){
        padding: 15px;
      }
    }
    & button{
      font-size: 20px;
      height: 60px;
      font-weight: 600;
      margin-top: 16px;
      cursor: pointer;
      @media screen and (max-width: 768px){
        font-size: 15px;
        line-height: 20px;
        height: 45px;
      }
    }
    & label{
      font-size: 16px;
      line-height: 32px;
      margin-bottom: 4px;
      margin-top: 16px;
      font-family: inherit;
      
      @media screen and (max-width: 768px){
        display: flex;
        justify-self: flex-start;
        font-size: 14px;
        line-height: 24px;
        margin-top: 12px;
      }
    }

    & p {
      color: red !important;
      font-size: 12px;
      margin: 4px 0px;
      @media screen and (max-width: 768px) { 
        display: flex;
        justify-self: flex-start;
      }
    }

    & span {
      font-size: 16px;
    }

    & img {
      position: absolute;
      right: 0;
      padding-right: 10px; 
      height: 55px;
      width: 90px;
      margin-top: 16px;
      @media screen and (max-width: 768px){
        width: 68px;
        height: 42px;
      }
    }
    & svg {
      display: none;
    }
`
